export default __webpack_public_path__ + "static/media/4250.18ea3110.png";